// Default packages
// ----------------

// jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('bootstrap');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//Moment.js
window.moment = require('moment');
require('moment/locale/nl');

// jQuery validation
require('jquery-validation');
require('jquery-validation/dist/localization/messages_nl');

// Cookie consent
require('cookieconsent');

// Optional packages
// -----------------

//select2
/*require('select2');
require('select2/src/js/select2/i18n/nl');
$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/');*/

// Slick
//require('slick-carousel');

// Lightbox
window.lightbox = require('lightbox2').option({
    'albumLabel': '%1 / %2'
});

// Tempus Dominus Boostrap 4
//window.datetimepicker = require('tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.min.js');
